module.exports = __webpack_public_path__ + "static/img/purchase-tips-1.26f7f13b.png";